var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"margin":"18px 0 0 0","height":"260px"}},[_c('a-spin',{attrs:{"spinning":_vm.spinning}},[(_vm.chartData.length)?_c('bar-chart-usage-top',{attrs:{"unit":"分","chart-data":_vm.chartData,"bar-color":_vm.barColor,"bg-color":_vm.bgColor,"height":260,"chart-id":"virtual-machine-storage-usage-chart"}}):_c('div',{staticStyle:{"height":"260px","position":"relative","overflow":"hidden"}},[_c('empty-component',{attrs:{"imgUrl":require('@/assets/images/info_empty.png'),"body-style":{
          height: '120px',
          marginTop: '48px'
        },"description-style":{
          marginTop: '-8px',
          marginRight: '8px'
        },"description":"暂无数据"}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }